import { Component } from '@angular/core';

@Component({
  selector: 'kh-loading-status',
  templateUrl: './loading-status.component.html',
  styleUrls: ['./loading-status.component.less'],
  standalone: false
})
export class LoadingStatusComponent {
}
